<template>
  <div class="ti d-flex">
    <!--    <div class="d-flex-left">-->

    <!--    </div>-->
    <div class="d-flex-right">
      <div class="header">
        <div style="margin: 5px 0">
          <div>
            <SelectCdjProjectHeader @onHeader="onHeader">

            </SelectCdjProjectHeader>
          </div>
        </div>
      </div>
      <LegalStatistics v-if="is_loading" ref="LegalStatistics" :projectIds="reginWhere.project_ids" :typeId="reginWhere.type_id" :regionId="reginWhere.project_region" :projectId="reginWhere.project_name" :areaId="reginWhere.area_id"  />
    </div>
  </div>
</template>

<script>
import LegalStatistics from "./LegalStatistics";
import SelectCdjProjectHeader from "./components/common/SelectCdjProjectHeader";

export default {
  name: "LegalStatisticsView",
  components: {SelectCdjProjectHeader, LegalStatistics},
  data() {
    return {
      is_loading:false,
      loading: false,
      type_list:[],
      project_region_list:[],
      reginWhere:{
        type_id:"",
        type_list:[],
        project_region:"",
        project_region_list:[],
        project_name:"",
        project_list:[],
        group_by:"",
        area_id:"",
        area_list:[],
        project_ids:[]
      },
    }
  },
  mounted() {
    const that=this;
  },
  activated() {
    const that=this;
  },
  methods: {
    getLegalStatistics(){
      const  that=this;
      setTimeout(function () {
        that.$refs.LegalStatistics.reData();
      },50)
    },
    onHeader(data){
      const that=this;
      that.reginWhere.type_id=data.type_id;
      that.reginWhere.type_list=data.type_list;
      that.reginWhere.project_region=data.project_region;
      that.reginWhere.project_region_list=data.project_region_list;
      that.reginWhere.project_region_level=data.project_region_level;
      that.reginWhere.project_name=data.project_name;
      that.reginWhere.project_list=data.project_list;
      that.reginWhere.group_by=data.group_by;
      that.reginWhere.area_id=data.area_id;
      that.reginWhere.area_list=data.area_list;
      that.reginWhere.project_ids=data.project_ids;
      that.reginWhere.level=data.level;
      that.is_loading=true;
      that.getLegalStatistics();
    }
  }
}
</script>

<style lang="scss" scoped>
@import "common";

.m-2{
  width: 150px;
}
.ti {
  margin: 1%;
  width: 98%;
}

.text1 {
  text-align: center;
}

.pages {
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}

.search {
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}

.text2 {
  color: rgb(250, 248, 248);
}

.kuan {
  width: 10%;
}

.zhanwu {
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}

.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
  margin: 30px;
  width: 100%;
  overflow-y: scroll;
  height: calc( 100vh - 150px );

  .header{
    padding-top: 5px;
    padding-bottom: 10px;
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1;
    background-color: #FFFFFF;
  }

  .btn-item {
    margin-top: 10px;
    margin-right: 30px;
  }
}
.view-file-win{
  height: 60vh;
  overflow-y: scroll;
  .main-log{
    margin: 10px 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/LegalStatisticsView.vue